import {
  Outlet, useOutletContext, useParams,
} from 'react-router-dom';
import { CreditProvider } from '../contexts/credit';
import { RoutingContextType } from '.';

export function CreditRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const { id } = useParams() as {id: string};

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <CreditProvider id={id}>
      <Outlet context={contextValue} />
    </CreditProvider>
  );
}
